import gql from 'graphql-tag';

const FavoriteProductFragment = gql`
  fragment FavoriteProductFragment on Product {
    favorite
  }
`;

export default FavoriteProductFragment;
